import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { NavController } from "@ionic/angular";

@Component({
  selector: "app-ion-common-header",
  templateUrl: "./header-v2.component.html",
  styleUrls: ["./header-v2.component.scss"],
})
export class HeaderV2Component {
  icon = "/assets/images/svg/arrow-left-white.svg";
  themeDark = false;
  private clicks = 0;
  private clicksTotal = 10;
  private timeout = 3000;
  private timer;

  @Input() id = "header-back";
  @Input() title = "";
  @Input() start = "";
  @Input() end = "";
  @Input() close;
  @Output() backHeader = new EventEmitter();
  @Input() set isDark(_isDark) {
    this.themeDark = _isDark;
    this.icon = _isDark
      ? "/assets/images/svg/arrow-left-white.svg"
      : "/assets/images/svg/arrow-left.svg";
  }

  constructor(public router: NavController) {}

  ngAfterViewInit(): void {
    this.hardFocusElement();
  }

  clickLabel() {
    if (
      !environment.production ||
      environment.id === "dev" ||
      environment.id === "staging"
    ) {
      if (!this.timer) {
        setTimeout(() => {
          this.clicks = 0;
          clearTimeout(this.timer);
        }, this.timeout);
      }

      this.clicks++;
      if (this.clicks >= this.clicksTotal) {
        this.clicks = 0;
        clearTimeout(this.timer);
        this.router.navigateForward("tools/settings");
      }
    }
  }
  hardFocusElement() {
    setTimeout(() => {
      {
        window.document.querySelector("button").focus();
      }
    }, 200);
  }
  back($event: any) {
    $event.preventDefault();
    this.backHeader.emit();
  }
}
